import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.split";
import _typeof from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/typeof";
import sha256 from 'crypto-js/sha256';
/**
 * @description: 联合类型输入length
 * @param {String | Number} value 判定变量
 * @return {Number} 结果
 */

function getLength(val) {
  if (typeof val === 'string') {
    return val.length;
  }

  return 0;
}
/**
 * @description: 获取host值
 * @param {*}
 * @return {string} 返回host
 */


var getHost = process.env.NODE_ENV === 'development' ? process.env.VUE_APP_SYSTEMADDRESS || '' : "".concat(window.location.protocol, "//").concat(window.location.host); // const getHost: string = process.env.NODE_ENV === 'development' ? 'https://ts-pre.hikyun.com:446' || '' : `${window.location.protocol}//${window.location.host}`

/**
 * @description: 将资源协议替换成与当前地址的协议
 * @param {string} 资源的url
 * @return {string} 替换后的资源url
 */

function formatProtocol(url) {
  if (url) {
    var protocol = "".concat(window.location.protocol, "//");

    if (url.indexOf(protocol) === -1) {
      url = "".concat(window.location.protocol).concat(url.substr(url.indexOf('/'), url.length));
    }
  }

  return url || '';
}
/**
 * 通用用户密码SHA256加密方法，用于验证密码
 * @param password 密码
 * @param salt 加密的盐
 * @param vCode 挑战码
 * @returns {String}  加密后密码
 */


function pwdHashEncryptVerify(password, salt, vCode) {
  return sha256(sha256(password + salt).toString() + vCode).toString();
}
/**
 * @description 判定是否是对象
 * @param {*} value 判定变量
 * @return {Boolean} 结果
 */


function isObject(value) {
  return value !== null && _typeof(value) === 'object';
}
/**
 * @description 深拷贝函数
 * @param {*} set 深拷贝对象
 * @returns  {*} cloneSet 深拷贝结果
 */


function deepClone() {
  var set = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!isObject(set)) {
    return set;
  }

  var cloneSet = Array.isArray(set) ? [] : {};

  for (var key in set) {
    if (set.hasOwnProperty(key)) {
      if (set[key] && _typeof(set[key]) === 'object') {
        cloneSet[key] = deepClone(set[key]);
      } else {
        cloneSet[key] = set[key];
      }
    }
  }

  return cloneSet;
}
/**
 * @description 阿拉伯数字转中文数字
 * @param {number} num 阿拉伯数字
 * @returns  String 中文数字
 */


function toChineseNum(num) {
  var changeNum = ['', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  var unit = ['', '十', '百', '千', '万'];
  num = Math.floor(num);

  var getWan = function getWan(temp) {
    var strArr = temp.toString().split('').reverse();
    var newNum = '';

    for (var i = 0; i < strArr.length; i++) {
      if (i === 0 && strArr[i] === 0 || i > 0 && strArr[i] === 0 && strArr[i - 1] === 0) {
        newNum = '';
      } else {
        newNum = (strArr[i] === 0 ? unit[0] : unit[i]) + newNum; // 排除一十二文本格式异常文字

        if (!(strArr.length === 2 && i === 1 && changeNum[strArr[i]] === '一')) {
          newNum = changeNum[strArr[i]] + newNum;
        }
      }
    }

    return newNum;
  };

  var overWan = Math.floor(num / 10000);
  var noWan = num % 10000;
  var temp = '';

  if (noWan.toString().length < 4) {
    temp = "0".concat(noWan);
    return overWan ? "".concat(getWan(overWan), "\u4E07").concat(getWan(temp)) : getWan(num);
  }

  return overWan ? "".concat(getWan(overWan), "\u4E07").concat(getWan(noWan)) : getWan(num);
}
/**
 * @description 加零函数
 * @param {Number || String} target 需要加零的目标
 * @returns  {String} result 加零后结果
 */


function addZero(target) {
  if (typeof target !== 'number' && typeof target !== 'string') {
    throw Error('请传入字符串或数字');
  }

  var result = target < 10 ? "0".concat(target) : target; // 统一转为字符串

  return "".concat(result);
}
/**
 * @description 生成32位随机数
 * @param
 * @returns {String}生成的uuid
 */


function createUuid() {
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  var maxPos = $chars.length;
  var pwd = '';

  for (var i = 0; i < 32; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }

  return pwd;
}
/**
 * @description 获取url参数
 * @param {String} 参数key
 * @returns {unknown} 当前查询参数赋值情况
 */


function getUrlSearch(name) {
  // 未传参，返回空
  if (!name) return null; // 查询参数：先通过search取值，如果取不到就通过hash来取

  var after = window.location.search;
  after = after.substr(1) || window.location.hash.split('?')[1]; // 地址栏URL没有查询参数，返回空

  if (!after) return null; // 如果查询参数中没有"name"，返回空

  if (after.indexOf(name) === -1) return null;
  var reg = new RegExp("(^|&)".concat(name, "=([^&]*)(&|$)")); // 当地址栏参数存在中文时，需要解码，不然会乱码

  var r = decodeURI(after).match(reg); // 如果url中"name"没有值，返回空

  if (!r) return null;
  return r[2];
}
/**
 * @description 获取文件的blob流
 * @author zhaoshuaiqin
 * @returns  {null}
 */


function getFileBlob(url, cb) {
  var xhr = new XMLHttpRequest();
  xhr.open('get', url, true);
  xhr.responseType = 'blob';

  xhr.onload = function () {
    if (this.status === 200) {
      if (cb) cb(this.response);
    }
  };

  xhr.send();
}
/**
 * @description 根据url下载oss文件
 * @author zhaoshuaiqin
 * @returns  {null}
 */


function downloadFromOssByUrl(baseUrl) {
  var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'downloadFile';
  var fileType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pdf';
  var url = baseUrl.replace(/((http)|(https)):\/\//, '//');
  console.log('文件下载', url);
  var timestamp = new Date().getTime();
  var link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', "".concat(fileName, "_").concat(timestamp, ".").concat(fileType));
  document.body.appendChild(link);
  link.click();
  link.remove(); // const xhr = new XMLHttpRequest();
  // xhr.open('get', url, true);
  // xhr.setRequestHeader('Referrer-policy', 'no-refer');
  // xhr.setRequestHeader('Referer', '//oss-cn-hangzhou.aliyuncs.com');
  // // xhr.setRequestHeader('Content-Type', 'application/octet-stream');
  // // xhr.setRequestHeader('Content-disposition', `attachment; filename=${encodeURIComponent(fileName)}.${fileType}; filename*=utf-8''${encodeURIComponent(fileName)}.${fileType};`);
  // xhr.responseType = 'blob';
  // xhr.onload = function () {
  //   if (this.status === 200) {
  //     const timestamp = new Date().getTime()
  //     const blobUrl = window.URL.createObjectURL(this.response);
  //     const link = document.createElement('a');
  //     link.style.display = 'none';
  //     link.href = blobUrl;
  //     link.setAttribute('download', `${fileName}_${timestamp}.${fileType}`);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(blobUrl)
  //     // window.navigator.msSaveBlob(this.response, fileName)
  //     // if (cb) cb(this.response);
  //   }
  // };
  // xhr.send();
}
/**
 * @description 获取转换为正确的base64图片
 * @author dongtao
 * @returns  {string} base64图片
 */


var transformBase64Image = function transformBase64Image(image) {
  return "data:image/jpeg;base64,".concat(image);
};
/**
 * @description 获取是否为移动端
 * @author dongtao
 * @returns  {RegExpMatchArray | null} match结果
 */


var mobileReg = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;

var isMobile = function isMobile() {
  return navigator.userAgent.match(mobileReg);
};
/**
 * @description 获取是否为IOS系统
 * @author dongtao
 * @returns  {RegExpMatchArray | null} match结果
 */


var iosReg = /(iPhone|iPod|ios|iPad)/i;

var isIos = function isIos() {
  return navigator.userAgent.match(iosReg);
};

export { getLength, deepClone, isObject, toChineseNum, addZero, createUuid, getUrlSearch, transformBase64Image, formatProtocol, pwdHashEncryptVerify, getHost, isMobile, isIos, downloadFromOssByUrl };